import { PickersDay } from '@mui/x-date-pickers';
import { styled } from '@mui/material/styles';

/** Calendar day slot that shades days inside a selected range with square corners. */
export const RangeHighlightDay = styled(PickersDay, {
  shouldForwardProp: prop => prop !== 'inRange',
})<{ inRange?: boolean }>(({ theme, inRange }) => ({
  ...(inRange && { backgroundColor: theme.palette.action.selected, borderRadius: 0 }),
}));
